import * as yup from 'yup'

import { getMessage } from '../../util/IntlMessages'

export const configSchema = yup.array().of(
  yup.object().shape({
    organizationId: yup.number(),
    organizationName: yup.string(),
    clientEditionPeriodEndDate: yup
      .string()
      .required(getMessage('isRequired', getMessage('clientEditionPeriodEndDate')))
      .nullable(),
    clientEditionPeriodStartDate: yup
      .string()
      .required(getMessage('isRequired', getMessage('clientEditionPeriodStartDate')))
      .nullable(),
    clientQuantity: yup.mixed().required(getMessage('isRequired', getMessage('clientQuantity'))),
    actionPlanningPeriodEndDate: yup
      .string()
      .required(getMessage('isRequired', getMessage('actionPlanningPeriodEndDate')))
      .nullable(),
    actionPlanningPeriodStartDate: yup
      .string()
      .required(getMessage('isRequired', getMessage('actionPlanningPeriodStartDate')))
      .nullable(),
    actionExecutionPeriodStartDate: yup
      .string()
      .required(getMessage('isRequired', getMessage('actionExecutionPeriodStartDate')))
      .nullable(),
    actionExecutionPeriodEndDate: yup
      .string()
      .required(getMessage('isRequired', getMessage('actionExecutionPeriodEndDate')))
      .nullable()
  })
)
